module.exports = require("@mario-kart/domain").TieHandler;
